import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { CheckoutButton } from './Button';
import { CountdownTimer } from './CountdownTimer';
const bonuses = [['100 Ready-to-Use Dance Fitness Class Ideas', '$12', 'Fresh themed sessions, music concepts, interval formats, cardio challenges, and seasonal workout ideas.'], ['50 Complete Dance Fitness Class Plans', '$12', 'Fully structured flows with choreography, timing, transitions, coaching tips, and cooldowns.'], ['365 Warm-Ups, Cool-Downs & Combinations', '$10', 'Activation sequences, mobility routines, rhythm transitions, and movement inspiration.'], ['Dance Fitness Monthly Challenges', '$12', 'Retention-focused challenges that build consistency, participation, and community.'], ['Instructor Planner & Business Toolkit', '$12', 'Scheduling, attendance, playlists, marketing, and productivity tools for your teaching business.']];
export function BonusSection() {
  return <section className="bg-white px-4 py-20 sm:py-24" data-id="element-15">
      <div className="mx-auto max-w-5xl" data-id="element-16">
        <header className="mb-12 text-center" data-id="element-17">
          <p className="headline-kicker inline-block rounded-full bg-violet-mist px-3 py-1 text-xs font-bold text-violet" data-id="element-18">
            BONUS RESOURCES
          </p>
          <h2 className="mt-4 font-display text-3xl font-black uppercase text-navy sm:text-5xl" data-id="element-19">
            Five bonuses. <span className="text-violet" data-id="element-20">Included free.</span>
          </h2>
        </header>
        <div className="grid gap-5 md:grid-cols-2" data-id="element-21">
          {bonuses.map(([title, value, description], index) => <motion.article key={title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className={`relative rounded-2xl border border-line bg-white p-7 shadow-sm ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-22">
              <span className="absolute right-0 top-0 rounded-bl-xl bg-violet px-3 py-1.5 text-xs font-bold text-white" data-id="element-23">
                BONUS {String(index + 1).padStart(2, '0')}
              </span>
              <GiftIcon className="mb-5 text-violet" size={28} data-id="element-24" />
              <h3 className="max-w-[80%] font-display text-xl font-extrabold uppercase text-navy" data-id="element-25">
                {title}
              </h3>
              <p className="mt-3 text-xs text-slate-500" data-id="element-26">
                Value: <s data-id="element-27">{value}</s>{' '}
                <strong className="ml-2 text-violet" data-id="element-28">FREE</strong>
              </p>
              <p className="mt-4 text-sm leading-relaxed text-slate-600" data-id="element-29">
                {description}
              </p>
            </motion.article>)}
        </div>
        <CountdownTimer data-id="element-30" />
        <div className="mt-8 text-center" data-id="element-31">
          <CheckoutButton data-id="element-32">GET INSTANT ACCESS</CheckoutButton>
          <p className="mt-3 text-xs text-slate-500" data-id="element-33">
            Instant digital access • Secure checkout • 7-day guarantee
          </p>
        </div>
      </div>
    </section>;
}